import 'dayjs/locale/th'
import dayjs, { Dayjs } from 'dayjs'
dayjs.locale('th')

export const createDate = () => dayjs().set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).toDate()

export const resetTime = (date: string) =>
    dayjs(date).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).toDate()

export const convertDateToDateString = (date: Dayjs, format = 'YYYY-MM-DD') => {
    if (date) return dayjs(date).format(format)
}

export const convertDateToFormatTH = (date: string | Dayjs, format = 'DD MMM BBBB') => {
    if (date) return dayjs(date).format(format)
}

export const dateForAPI = (date?: string | Dayjs | null, withoutTime?: boolean) => {
    if (date) {
        if (withoutTime) {
            return dayjs(date).format('YYYY-MM-DD')
        }
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    }
}

export const convertDateToFormatTHFullMonth = (date: string | Dayjs, format = 'D MMMM BBBB') => {
    if (date) return dayjs(date).format(format)
}
